import { useState, useEffect } from "react";
import { useAuth }     from "@context/AuthContext";
import { useNavigate } from "react-router-dom";
import axios           from "axios";
import { API_BASE, PROFILE_IMG_BASE } from "@config/env";


const post = (ep, fields) => { const fd=new FormData(); Object.entries(fields).forEach(([k,v])=>fd.append(k,v)); return axios.post(`${API_BASE}${ep}`,fd).then(r=>r.data).catch(()=>null); };
const emailPat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;

// Field must be outside component to avoid cursor loss on re-render
function RMField({ label, fKey, type="text", form, errors, onChange }) {
  const required = ["firstName","lastName","email"].includes(fKey);
  const hasErr = !!errors[fKey];
  return (
    <div style={{ marginBottom:14 }}>
      <label style={{ fontSize:11, fontWeight:700, color:"var(--fc-text-secondary)", display:"block", marginBottom:5, textTransform:"uppercase", letterSpacing:"0.05em" }}>
        {label}{required && " *"}
      </label>
      <input type={type} value={form[fKey]} onChange={e=>onChange(fKey, e.target.value)}
        placeholder={label}
        style={{ width:"100%", boxSizing:"border-box", padding:"10px 12px", border:`1.5px solid ${hasErr?"#DC2626":"var(--fc-border)"}`, borderRadius:9, fontSize:13, outline:"none", fontFamily:"inherit", color:"var(--fc-text-primary)", background:"var(--fc-card-bg)" }}
        onFocus={e=>e.target.style.borderColor=hasErr?"#DC2626":"#2563EB"}
        onBlur={e=>e.target.style.borderColor=hasErr?"#DC2626":"var(--fc-border)"} />
      {hasErr && <div style={{ fontSize:11, color:"#DC2626", marginTop:3 }}>{errors[fKey]}</div>}
    </div>
  );
}

export default function AddResourceManagerPage() {
  const { userSlug } = useAuth();
  const navigate = useNavigate();

  const [form,    setForm]    = useState({ firstName:"", lastName:"", email:"", contactEmail:"", phone:"", officePhone:"" });
  const [errors,  setErrors]  = useState({});
  const [busy,    setBusy]    = useState(false);
  const [success, setSuccess] = useState("");
  const [apiErr,  setApiErr]  = useState("");

  const set = (k, v) => { setForm(f=>({...f,[k]:v})); setErrors(e=>({...e,[k]:""})); };

  const validate = () => {
    const e = {};
    if (!form.firstName.trim()) e.firstName = "Required";
    if (!form.lastName.trim())  e.lastName  = "Required";
    if (!emailPat.test(form.email)) e.email = "Enter a valid email";
    setErrors(e);
    return !Object.keys(e).length;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;
    setBusy(true); setApiErr("");
    const res = await post("create-resource-manager-by-firm", {
      user_slug:     userSlug,
      first_name:    form.firstName,
      last_name:     form.lastName,
      email:         form.email,
      contact_email: form.contactEmail || form.email,
      phone:         form.phone,
      officePhone:   form.officePhone,
    });
    setBusy(false);
    if (res?.status === 1) { setSuccess(res.message || "Manager created successfully!"); }
    else setApiErr(res?.message || "Failed to create manager. Please try again.");
  };

  return (
    <div>
      <div style={{ marginBottom:20 }}>
        <button onClick={() => navigate("/resource-managers")} style={{ background:"none", border:"none", cursor:"pointer", color:"var(--fc-text-muted)", fontSize:13, padding:0, display:"flex", alignItems:"center", gap:6, marginBottom:8, fontFamily:"inherit" }}>
          <i className="fa-solid fa-arrow-left" style={{fontSize:11}} /> Back to managers
        </button>
        <h1 style={{ fontSize:20, fontWeight:800, color:"var(--fc-text-primary)", margin:0 }}>Add Resource Manager</h1>
        <p style={{ fontSize:13, color:"var(--fc-text-muted)", margin:"3px 0 0" }}>Create a new manager account for your firm</p>
      </div>

      <div style={{ background:"var(--fc-card-bg)", border:"1px solid var(--fc-border)", borderRadius:16, padding:28, boxShadow:"0 1px 4px rgba(0,0,0,0.04)", maxWidth:620 }}>
        {success ? (
          <div style={{ textAlign:"center", padding:"20px 0" }}>
            <div style={{ width:52, height:52, borderRadius:14, background:"var(--fc-green-light)", display:"flex", alignItems:"center", justifyContent:"center", margin:"0 auto 16px" }}>
              <i className="fa-solid fa-circle-check" style={{ fontSize:22, color:"var(--fc-green)" }} />
            </div>
            <h2 style={{ fontSize:17, fontWeight:700, color:"var(--fc-text-primary)", marginBottom:8 }}>Manager Created!</h2>
            <p style={{ fontSize:13, color:"var(--fc-text-muted)", marginBottom:20 }}>{success}</p>
            <div style={{ display:"flex", gap:8, justifyContent:"center" }}>
              <button onClick={()=>setSuccess("")} className="fc-btn fc-btn-sm fc-btn-ghost fc-btn-pill">Add another</button>
              <button onClick={()=>navigate("/resource-managers")} className="fc-btn fc-btn-sm fc-btn-primary fc-btn-pill">View managers</button>
            </div>
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            {apiErr && <div style={{ padding:"10px 12px", background:"var(--fc-red-light)", border:"1px solid var(--fc-red-border)", borderRadius:9, marginBottom:16, fontSize:13, color:"#DC2626" }}>{apiErr}</div>}
            <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:"0 16px" }}>
              <RMField form={form} errors={errors} onChange={set} label="First Name" fKey="firstName" />
              <RMField form={form} errors={errors} onChange={set} label="Last Name"  fKey="lastName" />
            </div>
            <RMField form={form} errors={errors} onChange={set} label="Email (Login)"     fKey="email"    type="email" />
            <div style={{ display:"flex", alignItems:"flex-start", gap:8, padding:"10px 12px", background:"var(--fc-primary-light)", borderRadius:9, marginBottom:14, fontSize:12, color:"var(--fc-text-secondary)" }}>
              <i className="fa-solid fa-circle-info" style={{ color:"var(--fc-primary)", marginTop:2, flexShrink:0 }} />
              <span>A temporary password will be generated automatically and emailed to this address.</span>
            </div>
            <div style={{ borderTop:"1px solid var(--fc-border-light)", margin:"16px 0", paddingTop:16 }}>
              <div style={{ fontSize:12, fontWeight:700, color:"var(--fc-text-secondary)", textTransform:"uppercase", letterSpacing:"0.05em", marginBottom:12 }}>Optional Details</div>
              <RMField form={form} errors={errors} onChange={set} label="Contact Email" fKey="contactEmail" type="email" />
              <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:"0 16px" }}>
                <RMField form={form} errors={errors} onChange={set} label="Phone"        fKey="phone" />
                <RMField form={form} errors={errors} onChange={set} label="Office Phone" fKey="officePhone" />
              </div>
            </div>
            <div style={{ display:"flex", justifyContent:"flex-end", gap:8, marginTop:4 }}>
              <button type="button" onClick={()=>navigate("/resource-managers")} className="fc-btn fc-btn-sm fc-btn-ghost fc-btn-pill">Cancel</button>
              <button type="submit" disabled={busy} className="fc-btn fc-btn-sm fc-btn-primary fc-btn-pill" style={{ minWidth:130 }}>
                {busy ? <><i className="fa-solid fa-spinner fa-spin" style={{fontSize:11}} /> Creating...</> : <><i className="fa-solid fa-user-plus" style={{fontSize:11}} /> Create Manager</>}
              </button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}